import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { showModal } from './actions'
import BudgetLineList from '../../components/BudgetLinesList';

class ModalComponent extends React.Component {

  constructor(props) {
    super(props)

    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    this.props.showModal(false, null)
  }

  render() {
    let service = this.props.service;
    return (
      <div className="static-modal">
        <Modal show={this.props.show} onHide={this.onClose}>
          <Modal.Header>
            <Modal.Title>Desglose de {service && service.name}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <BudgetLineList lines={service && service.serviceLines} />
          </Modal.Body>

          <Modal.Footer>
            <Button onClick={this.onClose}>Cerrar</Button>
          </Modal.Footer>

        </Modal>
      </div>)
  }
}

const mapStateToProps = (state) => ({
  show: state.checkout.shoppingCart.modal.show,
})

const bindActions = (dispatch) => ({
  showModal: (isVisible, content) => dispatch(showModal(isVisible, content)),
})

export default connect(mapStateToProps, bindActions)(ModalComponent)


// WEBPACK FOOTER //
// ./src/components/shoppingCart/modal.component.js